import { render } from "./cell_click_order.vue?vue&type=template&id=1463d812"
import script from "./cell_click_order.vue?vue&type=script&lang=ts"
export * from "./cell_click_order.vue?vue&type=script&lang=ts"
script.render = render

export default script